import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(DrawSVGPlugin, ScrollToPlugin);

const listeners = () => {
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.listener__button')) return;
    const button = document.querySelector('.listener__button');
    const section = document.querySelector('[data-alumni]');
    if (e.target.classList.contains('listener__button-active')) {
      button.classList.remove('listener__button-active');
      section.classList.remove('alumni__container-active');
    } else {
      button.classList.add('listener__button-active');
      section.classList.add('alumni__container-active');
    }
  });
};

const listenersArrow = () => {
  const arrowContainer = document.querySelector('.listener__arrow');
  if (!arrowContainer) return;
  // const svgLoops = gsap.utils.toArray('.listener__arrow svg g');
  // svgLoops.forEach((loop) => {
  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       start: 'top 75%',
  //       trigger: loop,
  //       scrub: true,
  //     },
  //   });
  //   tl.fromTo(
  //     loop,
  //     { drawSVG: '100% 100%' },
  //     { drawSVG: '0% 100%', fill: '#ffe102' },
  //     0,
  //   );
  // });
  const tl = gsap.timeline({
    scrollTrigger: {
      start: 'top 75%',
      trigger: arrowContainer,
      scrub: true,
    },
  });
  tl.fromTo(
    arrowContainer,
    { height: 0, rotation: 20 },
    { height: 'auto', rotation: 0 },
  );
};

const listenerLogos = () => {
  const logos = document.querySelectorAll('[data-logos] img');
  if (logos.length <= 0) return;
  const logosArr = [];
  const list1 = document.querySelector('[data-logo="0"]');
  const list2 = document.querySelector('[data-logo="1"]');
  const list3 = document.querySelector('[data-logo="2"]');

  logos.forEach((logo) => {
    logosArr.push(logo.src);
  });
  list1.innerHTML = `
    <img src="${logosArr[0]}" alt="" data-logoimg="0"/>
    <img src="${logosArr[3]}" alt="" data-logoimg="1"/>
  `;
  list2.innerHTML = `
    <img src="${logosArr[1]}" alt="" data-logoimg="2"/>
    <img src="${logosArr[0]}" alt="" data-logoimg="3"/>
  `;
  list3.innerHTML = `
    <img src="${logosArr[2]}" alt="" data-logoimg="4"/>
    <img src="${logosArr[4]}" alt="" data-logoimg="5"/>
  `;

  const tl = gsap.timeline({
    repeat: -1,
    yoyo: true,
  });
  tl.to('[data-logoimg="0"]', { opacity: 0 }, '+=2');
  tl.to('[data-logoimg="1"]', { opacity: 1 });
  tl.to('[data-logoimg="4"]', { opacity: 0 }, '+=2');
  tl.to('[data-logoimg="5"]', { opacity: 1 });
  tl.to('[data-logoimg="2"]', { opacity: 0 }, '+=2');
  tl.to('[data-logoimg="3"]', { opacity: 1 }, '+=2');
};

export const listenersAnimations = () => {
  listeners();
  // listenersArrow();
  listenerLogos();
};
